import React from 'react';
import WS_Loader from 'images/WS_Loader.gif';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';

const defaultStyles = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  width: '100%',
  height: '50vh',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255,255,255,0.7)',
  zIndex: '999',
};
function LogoSpinnerUpload({ style, logoSideLength, french }) {
  return (
    <div style={{ ...defaultStyles, ...style }}>
      {/* Waiting for fuctionality to cancel an in progress job
    <Popup
      trigger={<Close>x</Close>}
      content="Cancel Upload"
      position="bottom right"
    /> */}
      <img
        src={WS_Loader}
        height={logoSideLength}
        width="auto"
        alt="Wealthscope"
      />
      <Header size="small">
        {french
          ? 'Analyse de votre fiche d’évaluation — cela peut prendre jusqu’à 1 minute.'
          : 'Analyzing your scorecard — this may take up to 1 minute.'}
      </Header>
    </div>
  );
}

LogoSpinnerUpload.propTypes = {
  style: PropTypes.object,
  logoSideLength: PropTypes.number,
  french: PropTypes.bool.isRequired,
};

LogoSpinnerUpload.defaultProps = {
  style: { display: 'flex', flexDirection: 'column', rowGap: '2rem' },
  logoSideLength: 80,
};

export default LogoSpinnerUpload;

// const Close = styled.button`
//   background: none;
//   border: none;
//   color: dimgrey;
//   font-size: 25px;
//   cursor: pointer;
//   padding: 0;
//   text-align: center;
//   width: 40px;
//   height: 40px;
//   position: absolute;
//   top: 60px;
//   right: 10px;

//   :focus {
//     outline: none;
//   }

//   :hover {
//     color: ${colors.red};
//   }
// `;
